(function ($, Drupal) {
  Drupal.behaviors.menu_hamburger = {
    attach: function (context) {
      // Toggle the "open-menu" class on the button when clicked
      $('.btn-toggle').on('click', function () {
        $('.header__mobile').toggleClass('open-menu');
      });

      // Add the "scrolled" class to the header when scrolling
      const header = once('headerScroll', '.header', context)[0];
      if (!header) return;

      window.addEventListener('scroll', () => {
        if (window.scrollY > 50) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }
      });
    }
  };

  // Component for handling smooth scrolling.
  function handleSmoothScroll(hashValue) {
    let target = $(hashValue);
    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top
      }, function () {
        // Once the scrolling is complete, remove the value from local storage.
        localStorage.removeItem('hashValue');
      });
    }
  }

  // Component for capturing the hash value when clicking on a link.
  function handleHashCapture(isInternalPage) {
    $('ul.menu a[href^="#"]').on('click', function (e) {
      e.preventDefault();
      let targetId = this.getAttribute('href').substring(1);
      let target = '#' + targetId;
      if (isInternalPage) {
        // Store the value in local storage.
        localStorage.setItem('hashValue', target);
        window.location.href = '/';
      } else {
        handleSmoothScroll(target);
      }
    });
  }

    // Component for handling clicks on breadcrumb links.
    function handleHashBreadCrumbCapture() {
      $('.fbc-items a[href^="#"]').on('click', function (e) {
        e.preventDefault();
        let targetId = this.getAttribute('href').substring(1);
        let target = '#' + targetId;
        // Store the value in local storage.
        localStorage.setItem('hashValue', target);
        // Redirect to the homepage.
        window.location.href = '/';
      });
    }

  Drupal.behaviors.smoothScrollMainMenu = {
    attach: function (context) {
      let isInternalPage = window.location.pathname !== '/';
      let storedValue = localStorage.getItem('hashValue');

      if (storedValue) {
        setTimeout(function () {
          // Timeout is added only if it's an internal URL.
          handleSmoothScroll(storedValue);
        }, 1000);
      }

      handleHashCapture(isInternalPage);
      handleHashBreadCrumbCapture(isInternalPage)
    }
  };

})(jQuery, Drupal);
